export const SET_WEEK = 'SET_WEEK';
export const PAY_RATE_SUCCESS = 'PAY_RATE_SUCCESS';
export const JOB_ACCESS_SUCCESS = 'JOB_ACCESS_SUCCESS';
export const SET_GF_TIMESHEET_STATUSES = 'SET_GF_TIMESHEET_STATUSES';

export const setWeek = (payload: any) => ({
  type: SET_WEEK,
  payload,
});

export const setGFTimesheetStatuses = (payload: any) => ({
  type: SET_GF_TIMESHEET_STATUSES,
  payload,
});
